export default class{
  constructor(domElement, isFade, scrollEl){
    this.domElement = domElement
    this.isFade = isFade
    this.scrollEl = scrollEl
  }
  loadImg(){
    Array.from(this.domElement).forEach(function(item, index){
      if(isLoad.call(this, item)){
        if(item.className.indexOf('loaded') == -1){
          item.style.background = 'url(' + item.getAttribute('data-imgurl') + ') center center no-repeat'
          item.className = 'loaded'
        }
      }else{
        return false
      }
    }.bind(this))
  }

}
//获取元素距离页面顶部的距离
function getImgOffset(elem){
  let offsetTop = 0
  let scrollEl = this.scrollEl || document.body
  while(elem !== scrollEl && elem !== null){
    offsetTop += elem.offsetTop
    elem = elem.offsetParent
  }
  return offsetTop
}
function isLoad(item){
  let scrollEl = this.scrollEl
  let cHeight = window.innerHeight || document.body.clientHeight || document.documentElement.clientHeight,
    sx = scrollEl && scrollEl.scrollTop || window.pageYOffset || document.body.offsetTop || document.documentElement.offsetTop,
    thrs = 0,
    oTop = getImgOffset.call(this, item),
    vHeight = oTop - sx - thrs
  if(cHeight >= vHeight){
    return true
  }else{
    return false
  }
}



// WEBPACK FOOTER //
// ./src/libs/lazy.js